import { jsxs as i, Fragment as k, jsx as p } from "react/jsx-runtime";
import { Slot as w } from "../../node_modules/@radix-ui/react-slot/dist/index.es.js";
import t from "../../_virtual/index.es.js";
import D from "../../icons/WtnCheckmark.es.js";
import { wprStyles as S, wprDecimalStyles as l, wprMarkStyles as u } from "./Wpr.styles.es.js";
const g = ({
  asChild: d,
  hideMark: n,
  className: f,
  classNames: r,
  rating: o,
  rated: h
}) => {
  const m = d ? w : "data", [e, x] = (o || 0).toFixed(2).split(".");
  return /* @__PURE__ */ i(m, { className: t(S(), f, r == null ? void 0 : r.root), children: [
    o ? /* @__PURE__ */ i(k, { children: [
      e,
      ".",
      /* @__PURE__ */ p("span", { className: t(l(), r == null ? void 0 : r.decimal), children: x })
    ] }) : "-",
    !n && /* @__PURE__ */ p(D, { className: t(u(), r == null ? void 0 : r.mark), fill: h ? "#003A70" : "#D0D3DB", height: 8, width: 8 })
  ] });
};
export {
  g as default
};
//# sourceMappingURL=Wpr.es.js.map
